// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-language-dialog-content .mat-mdc-radio-button {
  margin: 0 10px;
}

.fi-dialog-select-language-panel.cdk-overlay-pane .mat-mdc-dialog-container .mat-mdc-dialog-surface.mdc-dialog__surface .mat-mdc-dialog-content.mdc-dialog__content {
  padding: 5px 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/components/dialog-select-language/dialog-select-language.component.scss"],"names":[],"mappings":"AACI;EACI,cAAA;AAAR;;AAIA;EAII,cAAA;AAJJ","sourcesContent":[".select-language-dialog-content {\r\n    .mat-mdc-radio-button {\r\n        margin: 0 10px;\r\n    }\r\n}\r\n\r\n.fi-dialog-select-language-panel.cdk-overlay-pane\r\n    .mat-mdc-dialog-container\r\n    .mat-mdc-dialog-surface.mdc-dialog__surface\r\n    .mat-mdc-dialog-content.mdc-dialog__content {\r\n    padding: 5px 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
